import type { RenderLink } from '@ui/web/utils'
import cn from '@config/tailwind/cn'

import { LovedBook } from './loved-book'
import { LovedBookCollection } from './loved-book-collection'

interface MyLovedBooksAndBookCollectionsProps {
  type: 'web' | 'school'
  bookLink: {
    renderBookLink: RenderLink
    renderEmptyBookLink: RenderLink
  }
  collectionLink: {
    renderCollectionLink: RenderLink
    renderEmptyCollectionLink: RenderLink
  }
  className?: string
}

export function MyLovedBooksAndBookCollections({
  type,
  bookLink,
  collectionLink,
  className,
}: MyLovedBooksAndBookCollectionsProps) {
  return (
    <main className={cn('srd:w-full srd:flex srd:flex-col srd:gap-y-10', className)}>
      <LovedBook type={type} renderEmptyLink={bookLink.renderEmptyBookLink} renderBookLink={bookLink.renderBookLink} />
      <LovedBookCollection
        type={type}
        renderEmptyLink={collectionLink.renderEmptyCollectionLink}
        renderCollectionLink={collectionLink.renderCollectionLink}
      />
    </main>
  )
}
